module.exports = __webpack_public_path__ + "img/p6.f1dbd65b.png";